import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { initClient } from '../../api';
import { WindowType } from '../../util';
import { AdminApiClient, IAdminApiClient } from "../backend/backendapi";
import { handleError } from '../../api';
import { blobDownload, formatDateTimeSeconds } from '../../util';
import UploadForm from './UploadForm';
import Toasted from 'vue-toasted';

declare var window: WindowType;
Vue.use(Toasted, { duration: 2000 });

/// setupcontroller used in map, works with prop and watcher, see https://johnpapa.net/vue-typescript/ (full example)
@Component(
    {
        name: 'setup',
        components: {
              UploadForm: require('./UploadForm.vue').default,
        }
    })
export default class SetupComponent extends Vue {
    //@Prop() poi: BasePoI | undefined;
    //items: BaseFile[] = [];
    PermissionDelete: boolean = true;
    fileName: string = "";
    file: any = {};
    private searchStr: string=""
    private readonly api: IAdminApiClient = initClient(AdminApiClient);
    private fileUploadField!: HTMLInputElement;

    mounted() {
        var self = this;
        this.fileUploadField = this.$refs.fileUploadField as HTMLInputElement;
        this.PermissionDelete = window.application.permissions.media.delete;
    }

    createDbs() {
        var self = this;

        console.log(" create");
        if (confirm("Do you really want to delete?")) {

            fetch(window.application.baseUrl + "admin/createdbs")
                .then(function (response) {
                    //console.log("response=" + response.json());
                    return response.json();
                })
                .then(function (result) {
                    // Push status to notification hub  //NOTRMARK
                    console.log(" create done result=", result.result);
                })
                .catch(function (error) { console.log("error:", error); });
        }
    }

    createAppActivity() {
        var self = this;

        console.log(" create");
        fetch(window.application.baseUrl + "admin/createAppActivity")
            .then(function (response) {
                //console.log("response=" + response.json());
                return response.json();
            })
            .then(function (result) {
                // Push status to notification hub  //NOTRMARK
                console.log(" create done result=", result.result);
            })
            .catch(function (error) { console.log("error:", error); });
    }

    CreateAppQrActivity() {
        var self = this;

        console.log(" CreateAppQrActivity");
        fetch(window.application.baseUrl + "admin/CreateAppQrActivity")
            .then(function (response) {
                //console.log("response=" + response.json());
                return response.json();
            })
            .then(function (result) {
                // Push status to notification hub  //NOTRMARK
                console.log(" create done result=", result.result);
            })
            .catch(function (error) { console.log("error:", error); });
    }

    createDuties() {
        var self = this;

        console.log(" create duties");
        fetch(window.application.baseUrl + "admin/CreateDuties")
            .then(function (response) {
                //console.log("response=" + response.json());
                return response.json();
            })
            .then(function (result) {
                // Push status to notification hub  //NOTRMARK
                console.log(" create done result=", result.result);
            })
            .catch(function (error) { console.log("error:", error); });
    }

    GetAccountList() {
        var self = this;

        console.log(" getAccountList");
         this.api.getAccountList()
            .then(_ => {
                console.log(_.data);
                this.$toasted.info(this.$t('txtDone').toString());
            })
            .catch(e => handleError(this.$toasted, this.$i18n, e));
            
    }

    GetAccountListCsv() {
        var self = this;
        console.log(" getAccountListCSV");
        this.api.getAccountListCsv(this.searchStr)
            .then(_ => {
                blobDownload(_.data, ('data' + '_' + formatDateTimeSeconds(new Date()) + '.csv'));
                this.$toasted.info(this.$t('txtDone').toString());
            })
            .catch(e => handleError(this.$toasted, this.$i18n, e));
    }

     GetClaimList() {
       var self = this;
        this.api.getRoleListCsv()
            .then(_ => {
                blobDownload(_.data, ('data' + '_' + formatDateTimeSeconds(new Date()) + '.csv'));
                this.$toasted.info(this.$t('txtDone').toString());
            })
            .catch(e => handleError(this.$toasted, this.$i18n, e));
    }

    
     GetUserList() {
       var self = this;
        this.api.getUserList()
            .then(_ => {
                blobDownload(_.data, ('data' + '_' + formatDateTimeSeconds(new Date()) + '.csv'));
                this.$toasted.info(this.$t('txtDone').toString());
            })
            .catch(e => handleError(this.$toasted, this.$i18n, e));
    }

    onPickFile(e) {
        this.file = e.target.files[0];
        this.fileName = e.target.files[0].name;
    }

    onFilePicked(e) {
        console.log("upload");
        const file = this.fileUploadField.files && this.fileUploadField.files[0];
        if (!file)
            return;
        this.api.upload({ data: file, fileName: file.name })
            .then(function (response) {
                console.log("response=" + response);
                return response;
            })
            .catch(function (error) { console.log("error:", error); });
    }
}